module.exports = __webpack_public_path__ + "r-v3/img/speaker_off_gray.963d8b15.svg";